module.exports = __webpack_public_path__ + "static/media/grandfather.5484fe42.jpg";